// Vuetify
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import "vuetify/styles";
import { md3 } from "vuetify/blueprints";
// Import Material Design Icons
import { aliases, mdi } from "vuetify/iconsets/mdi";
import "@mdi/font/css/materialdesignicons.css";
import "../styles/typography.scss";
import "../styles/vuetify_overrides.scss";
// Import VSkeletonLoader from labs
import * as labsComponents from "vuetify/labs/components";

const vuetify = createVuetify({
  components: {
    ...components,
    ...labsComponents,
  },
  directives,
  blueprint: md3,
  icons: {
    defaultSet: "mdi",
    aliases,
    sets: {
      mdi,
    },
  },
  aliases: {
    VBtnLh: components.VBtn,
  },
  defaults: {
    global: {
      fontFamily: "DM Sans",
      ripple: false,
    },
    VBtnLh: {
      rounded: true,
      size: "large",
      style: ["font-family: DM Sans; font-weight: 500; text-transform: none; letter-spacing: normal;"],
      class: ["text-body-1", "ps-5", "pe-5"],
      color: "primary",
      variant: "flat",
    },
    VBtn: {
      rounded: true,
      size: "large",
      style: ["font-family: DM Sans; font-weight: 500; text-transform: none; letter-spacing: normal;"],
      variant: "flat",
    },
    VTextField: {
      variant: "solo",
      class: "lh--text-field",
      hideDetails: "auto",
    },
    VTextarea: {
      variant: "solo",
      class: "lh--text-area",
      hideDetails: "auto",
    },
    VSelect: {
      variant: "solo",
      class: "lh--select-field",
      menuProps: {
        contentClass: "v-select__menu",
      },
      hideDetails: "auto",
    },
    VCheckbox: {
      class: "lh--checkbox",
      color: "accent",
      hideDetails: "auto",
    },
    VRadioGroup: {
      color: "accent",
      hideDetails: "auto",
    },
    VCard: {
      class: "lh--card",
      elevation: 0,
    },
    VExpansionPanels: {
      class: "lh--expansion-panel",
      color: "snow",
      elevation: 0,
    },
    VExpansionPanelTitle: {
      class: "lh--expansion-panel-title",
    },
    VExpansionPanelText: {
      class: "lh--expansion-panel-text",
    },
    VDateInput: {
      variant: "solo",
      class: "lh--date-input",
      prependIcon: "",
      hideDetails: "auto",
    },
    VAutocomplete: {
      variant: "solo",
      class: "lh--autocomplete",
      menuProps: {
        contentClass: "v-select__menu",
      },
      hideDetails: "auto",
    },
    VCombobox: {
      variant: "solo",
      class: "lh--combobox",
      menuProps: {
        contentClass: "v-select__menu",
      },
      hideDetails: "auto",
    },
  },
  theme: {
    defaultTheme: "light",
    themes: {
      light: {
        colors: {
          background: "#F4F5F7",
          surface: "#FEFEFE",
          primary: "#052E5E",
          secondary: "#DCE1EA",
          accent: "#2470CA",
          error: "#EB3D52",
          info: "#2196F3",
          success: "#3D9E4C",
          warning: "#F08523",
          snow: "#EFF2F7",
          "darker-snow": "#E3E8F0",
          "navy-dark": "#042143",
          "blue-gray": "#5E7898",
          "on-surface": "#042143", // Changes the color of the text on a "surface" like v-sheet
          "snowy-white": "#EFF2F7",
        },
      },
    },
  },
});

export default vuetify;
